// extracted by mini-css-extract-plugin
export default {"header":"PersonalHomePage_header__z8Ba5"};